<template>
    <div class="footer-content">
        <div class="title">
            <img src="../assets/logo-footer.webp" alt="logo" />
        </div>
        <div class="bottom">
            <div class="item">
                <img src="../assets/footer-icon1.webp" alt="" class="icon">
                <div class="text">+66 0855193237</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon2.webp" alt="" class="icon">
                <div class="text">105 ซอย ซอย เทิดราชัน 7 ถนนเทิดราชัน แขวงสีกัน เขตดอนเมือง กรุงเทพมหานคร 10210</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon3.webp" alt="" class="icon">
                <div class="text">cloud@kitdiventures.com</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon4.webp" alt="" class="icon">
                <div class="text">0105569014801</div>
            </div>
        </div>
        <div class="c">
            © 2026 Hak Cipta Milik KITDI VENTURES COMPANY LIMITED
        </div>
    </div>
</template>
<script setup>
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 273px;
    background: #161616;
    padding: 0 230px;
    box-sizing: border-box;

    .title {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 32px;
        margin-bottom: 42px;

        img {
            width: 225px;
            height: 41px;
            object-fit: contain;
        }
    }

    .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 19px;
        padding-bottom: 38px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.31);

        .item {
            display: flex;
            align-items: center;

            .icon {
                width: 27px;
                height: 27px;
                object-fit: contain;
                margin-right: 11px;
            }

            .text {
                max-width: 246px;
                font-weight: bold;
                font-size: 12px;
                color: #DCDCDC;
                line-height: 18px;
            }
        }
    }

    .c {
        font-weight: 500;
        font-size: 12px;
        color: #EAEAEA;
        line-height: 24px;
        text-align: center;
    }
}
</style>